import { BaseKey } from "@refinedev/core";
import SearchableSelect from "components/common/select/SearchableSelect";
import { IBrand } from "interfaces";
import { useEffect, useState } from "react";
import useDataGridStore from "stores/dataGridStore";
import useMetadataStore from "stores/metadataStore";

interface SelectBrandProps {
  isDisabled?: boolean | undefined;
  isOpen?: boolean | undefined;
}

const SelectBrand = ({ isDisabled, isOpen }: SelectBrandProps) => {
  const { isloading: metaDataIsLoading, metadata } = useMetadataStore();
  const { brands = [] } = metadata ?? {};
  const {
    activeFilterSelector,
    setActiveFilterSelector,
    setDataGridFilterStr,
  } = useDataGridStore();

  const [resetKey, setResetKey] = useState(0);

  useEffect(() => {
    if (
      activeFilterSelector !== "brandSelector" &&
      activeFilterSelector !== undefined
    ) {
      setResetKey((prev) => prev + 1);
    }
  }, [activeFilterSelector]);

  const handleBrandIdChange = (brandIdValue: BaseKey) => {
    setActiveFilterSelector("brandSelector");
    setDataGridFilterStr(`BrandId::equals::${brandIdValue}`);
  };

  const brandOptions = brands
    ?.map((brand: IBrand) => ({
      value: brand?.id,
      label: brand?.name,
    }))
    .sort((a, b) => (a.label ?? "").localeCompare(b.label ?? "", "sv"));

  return (
    <SearchableSelect
      key={resetKey}
      defaultOpen={false}
      options={brandOptions}
      onChange={handleBrandIdChange}
      placeholder={"Hämta varumärke"}
      isLoading={metaDataIsLoading}
      isTableCell={false}
      widthRem={18}
      isDisabled={isDisabled}
      isOpen={isOpen}
      autoFocus={false}
    />
  );
};

export default SelectBrand;
